import {type ChartAggOption} from 'src/generated/graphql';

import {type PanelProps} from '../../util/panelProps';
import {type ChartAreaOption} from '../../util/plotHelpers/chartTypes';
import {type PlotFontSizeOrAuto} from '../../util/plotHelpers/plotFontSize';
import {type GradientStop} from '../GradientPicker';

export type PCColumn = {
  accessor?: string; // should be something like export loss.value
  value?: string;
  log?: boolean;
  inverted?: boolean;
  displayName?: string;
  params?: {[key: string]: string};
};

export type PCConfig = {
  columns?: PCColumn[];
  dimensions?: string[];
  customGradient?: GradientStop[];
  gradientColor?: boolean;
  legendFields?: string[];
  chartTitle?: string;
  fontSize?: PlotFontSizeOrAuto;

  // grouping
  aggregate?: boolean; // user selected grouping
  aggregateMetrics?: boolean;
  groupAgg?: ChartAggOption;
  groupArea?: ChartAreaOption;
  groupRunsLimit?: number;
  groupBy?: string; // key to group by
  isGrouped?: boolean;
  useRunsTableGroupingInPanels?: boolean; // respect the runs table grouping in the chart
};

export type ParallelCoordPanelProps = PanelProps<PCConfig>;

export function getTitleFromConfig(config: PCConfig): string {
  return config.chartTitle ?? '';
}
